import React from 'react';
import styles from '../../../../styles/automationStudio/automationStudio.module.scss';

/**
 * Presentational page shell for Automation Studio.
 * Slots mirror the structure extracted from AutomationStudio/index.jsx.
 */
export default function AutomationStudioLayout({
    leftPanel,
    rightPanel,
    actionBar,
    hiddenFileInput,
    modals,
    overlayModals,
}) {
    return (
        <>
            <div className={styles.pageContainer}>
                <div className={styles.coverContainer}>
                    <div className={styles.workspaceContent}>
                        {leftPanel}
                        {rightPanel}
                        {hiddenFileInput}
                    </div>
                    {actionBar}
                </div>
                {modals}
            </div>
            {overlayModals}
        </>
    );
}
